// ── useAssistantHistory — historial de conversaciones con Evo Brain ─────────
// Lista completa + búsqueda por contenido (Eduardo, 2026-08-06). Volumen
// chico (30 conversaciones, 912 mensajes) — sin paginación, sin debounce
// agresivo, misma simplicidad que el resto del backend de esto.

import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export interface ConversationSummary {
  id: number;
  entityType: string;
  entityId: string | null;
  entityLabel: string;
  entityHref: string | null;
  createdAt: string;
  lastMessageAt: string;
  messageCount: number;
  preview: string | null;
}

export interface HistorySearchHit {
  messageId: number;
  conversationId: number;
  entityType: string;
  entityId: string | null;
  entityLabel: string;
  entityHref: string | null;
  role: string;
  snippet: string;
  createdAt: string;
}

export function useConversationsList() {
  return useQuery<{ conversations: ConversationSummary[] }>({
    queryKey: ['assistant-history-conversations'],
    queryFn: () => api.get<{ conversations: ConversationSummary[] }>('/api/assistant/history/conversations'),
  });
}

export function useHistorySearch(query: string) {
  return useQuery<{ hits: HistorySearchHit[] }>({
    queryKey: ['assistant-history-search', query],
    queryFn: () => api.get<{ hits: HistorySearchHit[] }>(`/api/assistant/history/search?q=${encodeURIComponent(query)}`),
    enabled: query.trim().length > 0,
  });
}
